export const R6_FIRMWARE_PRODUCT_ALLOWLIST = Object.freeze(["AM01R6"]);

export function isR6FirmwareProductAllowed(productId) {
  return R6_FIRMWARE_PRODUCT_ALLOWLIST.includes(
    String(productId || "")
      .trim()
      .toUpperCase()
  );
}

export function normalizeR6FirmwareResponse(payload) {
  if (!payload || payload.key !== "CBR6") {
    throw new Error("固件检查接口返回了不匹配的设备型号");
  }
  const version = String(payload.version || "").trim();
  const files = Array.isArray(payload.files) ? payload.files : [];
  const file = files.find((item) => /\.zip$/i.test(String(item?.name || "")));
  if (!version || !file) throw new Error("接口未返回可用的 R6 固件包");

  let url;
  try {
    url = new URL(file.url);
  } catch (_) {
    throw new Error("接口返回的 R6 固件地址无效");
  }
  if (
    url.protocol !== "https:" ||
    url.hostname !== "angrymiao-diy.oss-cn-shenzhen.aliyuncs.com" ||
    !/\.zip$/i.test(url.pathname)
  ) {
    throw new Error("接口返回的 R6 固件地址无效");
  }

  return {
    version,
    fileName: String(file.name).trim(),
    url: url.href,
    changelog: String(payload.changelog || "").trim(),
  };
}

function parseFirmwareVersion(version) {
  const match = String(version || "")
    .trim()
    .match(/(\d+(?:\.\d+)+)$/);
  return match ? match[1].split(".").map(Number) : null;
}

export function compareR6FirmwareVersions(currentVersion, nextVersion) {
  const current = parseFirmwareVersion(currentVersion);
  const next = parseFirmwareVersion(nextVersion);
  if (!current || !next) return null;
  const length = Math.max(current.length, next.length);
  for (let index = 0; index < length; index += 1) {
    const currentPart = current[index] || 0;
    const nextPart = next[index] || 0;
    if (currentPart !== nextPart) return currentPart < nextPart ? -1 : 1;
  }
  return 0;
}
